import React from 'react';

import withPensionExpertTier from '../../util/pensionExpertTier/withPensionExpertTier';

import NotificationBanner from '../NotificationBanner/NotificationBanner';

const VulnerableCustomerNotification = ({
  latestConversationId,
  isPoolExpert,
  expertRoleTitle,
}) => {
  return (
    <NotificationBanner
      alertCategory={'Red'}
      alertTitle={isPoolExpert
        ? 'Please contact our Pension Experts'
        : `Please contact your ${expertRoleTitle}`}
      expandableAlertDescription={isPoolExpert
        ? 'The answers to the questions we have asked you about your mental health and ability to make financial decisions mean that we need to speak to you before we confirm your recommended pension plan. Please contact our Pension Experts to resolve this.'
        : `The answers to the questions we have asked you about your mental health and ability to make financial decisions mean that we need to speak to you before we confirm your recommended pension plan. Please contact your ${expertRoleTitle} to resolve this.`}
      ctaButtonOptions={{
        size: 'large',
        label: isPoolExpert ? 'Message our Pension Experts' : `Message my ${expertRoleTitle}`,
        to: latestConversationId ? `/inbox/${latestConversationId}` : 'inbox/new-message',
      }}
    />
  );
};

export default withPensionExpertTier(VulnerableCustomerNotification);
